import { getIconByName } from '../../styles';
import {CONTRACT_TYPE, ICON_COLORS, ICONS, TECHNOLOGY} from '../enums/generic.enum';

export class TechnologyIconCellRenderer {
  init(params) {
    if (!params.data) {
      return null;
    }

    this.content = document.createElement('span');
    this.content.setAttribute('part', 'iconWrapper');

    const width = '13px';
    const height = '16px';
    let fill = '';

    this.content.setAttribute('part', 'iconWrapper');
    if (
      params.data.RFQ_CONTRACT_TYPE === CONTRACT_TYPE.NEW_BUILD_PPA ||
      params.data.RFQ_CONTRACT_TYPE === CONTRACT_TYPE.NEW_BUILD_VPPA
    ) {
      fill = ICON_COLORS.NEW_BUILD_PROJECT_STATUS;
    } else if (
      params.data.RFQ_CONTRACT_TYPE === CONTRACT_TYPE.POST_BUILD_PPA ||
      params.data.RFQ_CONTRACT_TYPE === CONTRACT_TYPE.POST_BUILD_VPPA ||
      params.data.RFQ_CONTRACT_TYPE === CONTRACT_TYPE.MINI_POST_BUILD_VPPA_AUTO_EXECUTED
    ) {
      fill = ICON_COLORS.POST_BUILD_PROJECT_STATUS;
    } else if (params.data.RFQ_CONTRACT_TYPE === CONTRACT_TYPE.REC) {
      fill = ICON_COLORS.REC_STATUS;
    }

    if (params.data.RFQ_TECHNOLOGY ===  TECHNOLOGY.SOLAR)
      this.content.innerHTML = getIconByName(ICONS.SOLAR_TECHNOLOGY, null, width, height, fill);

    if (params.data.RFQ_TECHNOLOGY === TECHNOLOGY.WIND)
      this.content.innerHTML = getIconByName(ICONS.WIND_TECHNOLOGY, null, width, height, fill);

    if (params.data.RFQ_TECHNOLOGY === TECHNOLOGY.BOTH) {
      const windIcon = document.createElement('span');
      windIcon.setAttribute('part', 'iconWrapper');
      windIcon.innerHTML = getIconByName(ICONS.WIND_TECHNOLOGY, null, width, height, fill);
      windIcon.style.marginRight = '5px';
      this.content.appendChild(windIcon);
      const solarIcon = document.createElement('span');
      solarIcon.setAttribute('part', 'iconWrapper');
      solarIcon.innerHTML = getIconByName(ICONS.SOLAR_TECHNOLOGY, null, width, height, fill);
      this.content.appendChild(solarIcon);
    }
  }

  content: HTMLElement;

  getGui(): HTMLElement {
    return this.content;
  }

  refresh(): boolean {
    return false;
  }
}
